import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { ContainerInfo } from '../../types';
import { tableFilters } from './tableFiters';
import styles from './ContainerListTable.module.scss';

type ContainerListTableProps = {
  data?: ContainerInfo[];
  isLoading?: boolean;
};

const ContainerListTable: FC<ContainerListTableProps> = ({
  data,
  isLoading,
}) => {
  const tableColumns = getTableColumns(data);

  return (
    <div className={styles.containerListTable}>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        filterDisplay="menu"
      />
    </div>
  );
};

export default ContainerListTable;
